// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"314":"c658be2a","323":"9b80d29a","442":"7b0966c8","622":"03228165","628":"965c1478","634":"00ca8f74","772":"22324967"}[chunkId] + ".js";
};